export const queryKeys = {
  QUESTIONS: 'QUESTIONS',
  SEARCH: 'SEARCH',
  PAGINATION: 'PAGINATION',
  CHAPTERS: 'CHAPTERS',
  CHALLENGES: 'CHALLENGES',
  CHALLENGE_RESULTS: 'CHALLENGE_RESULTS',
  SUBJECTS: 'SUBJECTS',
  SETTINGS: 'SETTINGS',
  QUIZ_TYPES: 'QUIZ_TYPES',
  LESSON_CATEGORIES: 'LESSON_CATEGORIES',
  Media_LESSONS: 'Media_LESSONS',
  LESSON_SECTIONS: 'LESSON_SECTIONS',
  LESSONS: 'LESSONS',
  MINDMAPS: 'MINDMAPS',
  LEXIQUES: 'LEXIQUES',
  FICHES: 'FICHES',
  AVATARS: 'AVATARS',
  ACCESSORIES: 'ACCESSORIES',
  SPECIAL_OBJECTS: 'SPECIAL_OBJECTS',
  BADGES: 'BADGES',
  OBJECTS: 'OBJECTS',
  SUBSCRIPTIONS: 'SUBSCRIPTIONS',
  FAQS: 'FAQS',
  ADMINS: 'ADMINS',
  USERS: 'USERS',
  USER: 'USER',
  REVIEWS: 'REVIEWS',
  QUESTION_REPORT: 'QUESTION_REPORT',
  BADGE_TYPES: 'BADGE_TYPES',
  SPECIAL_OBJECT_TYPES: 'SPECIAL_OBJECT_TYPES',
  ABOUT: 'ABOUT',
  USER_SUBSCRIPTIONS: 'USER_SUBSCRIPTIONS',
  QUESTIONS_CURENT_PAGE_NUMBER: 'QUESTIONS_CURENT_PAGE_NUMBER',
  REVIEWS_CURENT_PAGE_NUMBER: 'REVIEWS_CURENT_PAGE_NUMBER',
  QUESTION_REPORT_CURENT_PAGE_NUMBER: 'QUESTION_REPORT_CURENT_PAGE_NUMBER',
  GRADES: 'grades',
  CREATE_SUBJECTS: 'create_subject',
  UPDATE_SUBJECTS: 'update_subject',
  DELETE_SUBJECTS: 'delete_subject',
  UPDATE_GRADE: 'update_grade',
  GET_SUBJECT_MENUS: 'get_subject_menus',
  PUT_SUBJECT_MENUS: 'put_subject_menus',
  GET_ACT_KEYS: 'get_act_keys',
  POST_ACT_KEY: 'post_act_key',
  PUT_ASSIGN_TO_USER: 'put_assign_to_user',
  GET_ALL_USERS: 'get_all_users',
  POST_EXPORT_ACT_KEYS: 'post_export_act_keys',
  GET_AGG_REPORTS: 'get_agg_reports',
  GET_USER_METRICS: 'get_user_metrics',
  GET_USER_CONTENTS: 'get_user_contents',
  GET_USER_ACTIVITIES: 'get_user_activities',
  GET_AVATAR_CHANGE: 'get_avatar_change',
  GET_FRIEND_DUEL: 'get_friend_duel',
  GET_RANDOM_DUEL: 'get_random_duel',
  GET_KEYS_PROGRESS: 'get_keys_progress',
  GET_LEVEL_UP: 'get_level_up',
  POST_CHANGE_AVATAR_AUDIO: 'port_change_avatar_audio',
  POST_CHANGE_AVATAR_BACKGROUND: 'port_change_avatar_background',
  POST_CHANGE_AVATAR_FOREGROUND: 'port_change_avatar_foreground',
  POST_CHANGE_AVATAR: 'port_change_avatar',
  POST_FRIEND_DUEL_AVATAR: 'post_friend_duel_avatar',
  POST_FRIEND_DUEL_AUDIO: 'post_friend_duel_avatar',
  POST_FRIEND_DUEL_BACKGROUND: 'post_friend_duel_background',
  POST_FRIEND_DUEL_FOREGROUND: 'post_friend_duel_foreground',
  POST_RANDOM_DUEL_FOREGROUND: 'post_random_duel_foreground',
  POST_RANDOM_DUEL_AVATAR: 'post_random_duel_avatar',
  POST_KEY_PROGRESS: 'post_key_progress',
  POST_LEVEL_UP_AVATAR: 'post_level_up_avatar',
  POST_LEVEL_UP_STAR: 'post_level_up_star',
  POST_LEVEL_UP_AUDIO: 'post_level_up_audio'
};
